import script from "./prlog.vue?vue&type=script&setup=true&name=projectMange&lang=js"
export * from "./prlog.vue?vue&type=script&setup=true&name=projectMange&lang=js"

import "./prlog.vue?vue&type=style&index=0&id=0509b7f8&scoped=true&lang=scss"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0509b7f8"]])

export default __exports__